import { render } from "./Chart.htm?vue&type=template&id=9fc289d6&scoped=true"
import script from "./Chart.js?vue&type=script&lang=js"
export * from "./Chart.js?vue&type=script&lang=js"

import "./Chart.scss?vue&type=style&index=0&id=9fc289d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc289d6"]])

export default __exports__